import gql from 'graphql-tag'

export const REFRESH_TOKEN_MUTATION = gql`
  mutation RefreshTokenMutation($refreshToken: String!) {
    refreshToken(
      refreshToken: $refreshToken
    ) {
      token
      refreshToken
    }
  }
`

export const GET_CANDIDATES_WITH_MATCHING_PROGRAM_QUERY = gql`
  query GetCandidatesWithMatchingProgramQuery($location: String!, $program: String!) {
    getCandidatesWithMatchingProgram(
      location: $location,
      program: $program
    ) {
      candidates {
        id,
        firstName,
        lastName,
        program,
        imageUrl,
        availability,
        estCompletionDate,
        location,
        numGoldBadges,
        numSilverBadges,
        numBronzeBadges
      }
      percentSkillsMatch
    }
  }
`
export const GET_CANDIDATES_WITH_MATCHING_SKILL_QUERY = gql`
  query GetCandidatesWithMatchingSkillQuery($location: String!, $skill: String!) {
    getCandidatesWithMatchingSkill(
      location: $location,
      skill: $skill
    ) {
      candidates {
        id,
        firstName,
        lastName,
        program,
        imageUrl,
        availability,
        estCompletionDate,
        location,
        numGoldBadges,
        numSilverBadges,
        numBronzeBadges
      }
      percentSkillsMatch
    }
  }
`
export const GET_NUM_CANDIDATES_WITH_MATCHING_SKILL_QUERY = gql`
  query GetNumCandidatesWithMatchingSkillQuery($location: String!, $skillNames: [String!]!) {
    getNumCandidatesWithMatchingSkill(
      location: $location,
      skillNames: $skillNames
    ) {
      numCandidatesWithMatchingSkill
    }
  }
`

export const UPDATE_PERSONAL_INFO = gql`
  mutation UserUpdateReq($uuid: ID!, $updates: UserUpdateInput!) {
    userUpdate(
      uuid: $uuid,
      updates: $updates,
    ) {
      uuid
      firstName,
      middleName,
      lastName,
      email,
      phoneNumber,
      avatarUrl
    }
  }
`

export const FETCH_PERSONAL_INFO = gql`
  query UserFetchReq($input: ID) {
    user(uuid: $input) {
      uuid
      firstName,
      middleName,
      lastName,
      email,
      phoneNumber,
      avatarUrl
    }
  }
`

export const FETCH_CAREER_INFORMATION = gql`
  query CareerFetchReq($input: ID) {
    user(uuid: $input) {
      uuid
      career {
        estimatedProgramCompletionDate
        isSeekingEmployment
        isSeekingOnsite
        isSeekingRemote
        isSeekingExternship
        isPartTime
        isFullTime
        location {
          city
          stateIsoCode
          postalCode
          googlePlaceId
        }
        distanceWithinMiles
      }
    }
  }
`

export const FETCH_WORK_EDUCATION = gql`
  query WorkExperienceFetchReq($input: ID) {
    user(uuid: $input) {
      uuid
      bio
      languages
      workExperiences {
        id
        title
        companyName
        city
        stateIsoCode
        startMonth
        startYear
        endMonth
        endYear
        jobDescription
      }
      educations {
        id
        degree
        institution
        city
        stateIsoCode
        graduationYear
      }
    }
  }
`

export const GET_PUBLIC_PROFILE_INFO = gql`
  query getPublicProfileInfo ($uuid: ID) {
  user(uuid: $uuid){
    avatarUrl
    bio
    languages
    firstName
    middleName
    lastName
    currentProgram
    educations {
      id
      degree
      graduationYear
      institution
      city
      stateIsoCode
    }
    career {
      estimatedProgramCompletionDate
      isFullTime
      isPartTime
      location {
        city
        stateIsoCode
      }
    }
    workExperiences {
        id
        title
        companyName
        city
        stateIsoCode
        startMonth
        startYear
        endMonth
        endYear
        jobDescription
      }
  }
}
`

export const GET_SIGNED_URL_PROFILE_PHOTO_JPG = gql`
  mutation {
    requestSignedS3Url(req: {
      objectType: PROFILE_PICTURE
      contentType: JPG
    }) {
      url
      fileKey
    }
  }
`

export const GET_SIGNED_URL_PROFILE_PHOTO_PNG = gql`
  mutation {
    requestSignedS3Url(req: {
      objectType: PROFILE_PICTURE
      contentType: PNG
    }) {
      url
      fileKey
    }
  }
`

export const REMOVE_PROFILE_PHOTO = gql`
  mutation RemoveProfilePhoto {
    removeProfilePhoto {
      httpStatusCode
    }
  }
`
